module.exports = __webpack_public_path__ + "assets/retina_SquareBy4PtDetailed.c3d37d23ec6616871efec147c3f9388b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SquareBy4PtDetailed.png
// module id = 718
// module chunks = 0